// import Company from '@/views/register/user/Company'
// import EditUser from '@/views/register/user/EditUser'
// import NewUser from '@/views/register/user/NewUser'
// import CompanyUsers from '@/views/register/user/CompanyUsers'
// import EditUserGroup from '@/views/register/user/EditUserGroup'
// import NewUserGroup from '@/views/register/user/NewUserGroup'
// import GroupUsers from '@/views/register/user/GroupUsers'
const Company = () => import('@/views/register/user/Company');
const EditUser = () => import('@/views/register/user/EditUser');
const NewUser = () => import('@/views/register/user/NewUser');
const CompanyUsers = () => import('@/views/register/user/CompanyUsers');
const EditUserGroup = () => import('@/views/register/user/EditUserGroup');
const NewUserGroup = () => import('@/views/register/user/NewUserGroup');
const GroupUsers = () => import('@/views/register/user/GroupUsers');

import getWhiteLabel from '@/utils/getWhiteLabel';

import Index from '@/views/Index.vue';

const userRouter = {
    path: '/user',
    component: Index,
    name: 'user',
    meta: {
        requiresAuth: true
    },
    children: [{
            name: 'client/users',
            path: '/',
            component: Company,
            meta: {
                title: `${getWhiteLabel()} - Usuários`,
                requiresAuth: true
            },
        },
        {
            name: 'client/users',
            path: 'company/:idCNPJ',
            component: CompanyUsers,
            meta: {
                title: `${getWhiteLabel()} - Usuários`,
                requiresAuth: true
            },
        },
        {
            name: 'client/users',
            path: 'company/:idCNPJ/new',
            component: NewUser,
            meta: {
                title: `${getWhiteLabel()} - Novo usuário`,
                requiresAuth: true
            },
        },
        {
            name: 'client/users',
            path: 'company/:idCNPJ/edit/:idUser',
            component: EditUser,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/users',
            path: 'edit/:idUser',
            component: EditUser,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
        {
            name: 'client/users',
            path: 'group/:groupId',
            component: GroupUsers,
            meta: {
                title: `${getWhiteLabel()} - Usuários`,
                requiresAuth: true
            },
        },
        {
            name: 'client/users',
            path: 'group/:groupId/new',
            component: NewUserGroup,
            meta: {
                title: `${getWhiteLabel()} - Novo usuário`,
                requiresAuth: true
            },
        },
        {
            name: 'client/users',
            path: 'group/:groupId/edit/:idUser',
            component: EditUserGroup,
            meta: {
                title: `${getWhiteLabel()} - Cadastro`,
                requiresAuth: true
            },
        },
    ]
}

export default userRouter;